export default "__VITE_ASSET__CvU7NWFi__"